import { Injectable } from "@angular/core";
import { AngularFirestore } from "angularfire2/firestore";
import { take } from "rxjs/operators";

/*
  Generated class for the ChatProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ChatProvider {
  collection: any;

  constructor(private afs: AngularFirestore) {}

  async createChat(chat) {
    // console.log("createChat", chat);
    if (!this.collection) this.collection = await this.afs.collection("chats");

    await this.collection.add(chat);
  }

  async getLiveChat(event_id) {
    let result = [];
    // console.log("getLiveChat", event_id);
    await this.afs
      .collection("events")
      .doc(event_id)
      .collection("messages", ref => ref.orderBy("created_at"))
      .snapshotChanges()
      .pipe()
      .subscribe(messages => {
        // console.log("getChat messages", messages);
        // console.log("getChat messages", messages.length);
        if (messages.length == 0) return [];
        for (let item of messages) {
          // console.log("item", item);
          let message = item.payload.doc.data();
          message["id"] = item.payload.doc.id;
          result.push(message);
        }
        return result;
      });
  }

  async getChat(event_id) {
    // console.log("getChat", event_id);
    let ref = await this.getChatSnapshot(event_id);
    ref.pipe(take(1)).subscribe(async actions => {
      actions.map(a => {
        const data = a.payload.doc.data();
        const id = a.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  async getChatSnapshot(event_id) {
    // console.log("getChatSnapshot", event_id);
    return await this.afs
      .collection("events")
      .doc(event_id)
      .collection("messages", ref => ref.orderBy("created_at"))
      .snapshotChanges();
  }

  async getUserChat(user_id) {
    // console.log("getUserChat", user_id);
    return new Promise<any>((resolve, reject) => {
      let today = Date.now();
      let result = [];
      this.afs
        .collection("events", ref => {
          return ref.where("users", "array-contains", user_id).where("status", "==", 1).where("time_finish", ">", today)
        }
        )
        .snapshotChanges()
        .pipe(take(1))
        .subscribe(async events => {
          // console.log("getUserChat events", events);
          if(events.length == 0)
            resolve([]);
          for (let item of events) {
            // console.log("item", item);
            let event = item.payload.doc.data();
            event["id"] = item.payload.doc.id;
            event["last_message"] = await this.getLastMessage(event["id"]);
            result.push(event);
            if (result.length == events.length){
              // console.log("getUserChat result", result);
              resolve(result);
            }
          }
        });
    });
  }

  async getLastMessage(event_id) {
    // console.log("getLastMessage", event_id);
    return new Promise<any>((resolve, reject) => {
      this.afs
        .collection("events")
        .doc(event_id)
        .collection("messages", ref => ref.orderBy("created_at",'desc').limit(1))
        .snapshotChanges()
        .pipe()
        .subscribe(last_messages => {
            console.log("last_messages",last_messages);
            let data;
            let id;
            if(last_messages.length > 0){
              data = last_messages[0].payload.doc.data();
              id = last_messages[0].payload.doc.id;
            }
            else{
              data = {created_at: 1549278116018, text: null, user_id: null};
              id = 0;
            }
            console.log("last_messages data",data);
            resolve({ id, ...data });
      });
    });
  }

  async sendMessage(event_id, user_id, content) {
    // console.log("sendMessage event_id", event_id);
    // console.log("sendMessage uid", user_id);
    // console.log("sendMessage content", content);
    const data = {
      user_id: user_id,
      text: content,
      created_at: Date.now()
    };
    // console.log("data", data);

    await this.afs
      .collection("events")
      .doc(event_id)
      .collection("messages")
      .add(data);
  }
}



// WEBPACK FOOTER //
// ./src/providers/chat/chat.provider.ts